import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonLabel,
  IonList,
  IonListHeader,
  IonLoading,
  IonMenuButton,
  IonModal,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonRow,
  IonSkeletonText,
  IonTitle,
  IonToolbar,
  RefresherEventDetail,
  useIonLoading,
  useIonViewDidEnter,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonFooter,
  IonItem,
  IonSpinner,
  useIonToast,
} from "@ionic/react";
import { useHistory, useLocation, useParams } from "react-router";

import plnSymbol from "../../../assets/img/logo/pln_symbol.svg";
import Navbar from "../../../components/WebApp/Navbar/Navbar";
import PubSub from "../../../lib/PubSub";
import scheduler from "../../../assets/img/icons/scheduler.png";
import { useEffect, useMemo, useRef, useState } from "react";
import {
  calendar,
  calendarClearOutline,
  cashOutline,
  checkmarkCircle,
  checkmarkCircleOutline,
  chevronForward,
  closeOutline,
  copyOutline,
  create,
  createOutline,
  ellipsisVertical,
  navigateCircle,
  pencil,
  pencilSharp,
  pricetag,
  pricetags,
  settings,
  share,
  shareOutline,
} from "ionicons/icons";

import consultImage from "../../../assets/img/brand/consultation.jpg";
import referralImage from "../../../assets/img/brand/give20get20.jpg";
import StorageUtils from "../../../lib/StorageUtils";
import API from "../../../lib/API";
import StringUtils from "../../../lib/StringUtils";
import moment from "moment";
import Constants from "../../../lib/Constants";
import Event from "../../../lib/Event";
import InlineSchedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineSchedulingModal";
import InlineReschedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineReschedulingModal";
import AppointmentInformation from "../../../components/Scheduler/AppointmentInformation/AppointmentInformation";
import DateUtils from "../../../lib/DateUtils";
import UpcomingOrderCard from "../../../components/AccountManagement/UpcomingOrderCard/UpcomingOrderCard";
import ReviewOrderCard from "../../../components/AccountManagement/ReviewOrderCard/ReviewOrderCard";
import _ from "underscore";
import MealDetailContent from "../../../components/MealDetailContent";
import SEOHeaders from "../../../components/SEOHeaders";
import { Capacitor } from "@capacitor/core";
import LinkUtils from "../../../lib/LinkUtils";
import OneSignal from "onesignal-cordova-plugin";
import { PushNotifications } from "@capacitor/push-notifications";
import BillingAddressForm from "../../../components/BillingAddressForm";
import SchedulingCalendarV2 from "../../../components/Scheduler/SchedulingCalendar/SchedulingCalendarV2";

const ConsultationSchedulerPage: React.FC<{
  nativeMode?: boolean;
  showBackButton?: boolean;
  allowSkip?: boolean;
  next: () => void;
  previous: () => void;
  hasNext: boolean;
  hasPrevious: boolean;
  step: any;
  title?: string;
  subtitle?: string;
  pageName?: string;
}> = ({
  nativeMode = false,
  showBackButton = false,
  allowSkip = false,
  next,
  previous,
  hasNext,
  hasPrevious,
  step,
  title,
  subtitle,
  pageName,
}) => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const pageRef = useRef();
  const [modalOpen, setModalOpen] = useState(false);

  const [user, setUser] = useState<any>(null);
  const [newMemberGoals, setNewMemberGoals] = useState<any>([]);
  const [submitting, setSubmitting] = useState(false);

  const [existingAppointment, setExistingAppointment] = useState<any>(null);
  const [appointmentDate, setAppointmentDate] = useState<any>(null);
  const [appointmentDateTime, setAppointmentDateTime] = useState<any>(null);
  const [appointmentFormValues, setAppointmentFormValues] = useState<any>({
    name: "",
    email: "",
    phone: "",
    address: "",
  });
  const [store, setStore] = useState<any>({});
  const [present] = useIonToast();

  useIonViewDidEnter(() => {
    PubSub.publish("mobileScreenChange");

    StorageUtils.get("user_customer").then((user) => {
      setUser(user);

      // Set the name email and phone from user information
      let phone = StringUtils.formatPhoneNumberWhileTyping(user?.phone);
    });

    StorageUtils.get("customer_store").then((store) => {
      setStore(store);
    });
  }, []);

  const scheduleNewMemberConsult = () => {
    setSubmitting(true);

    let phone = appointmentFormValues?.phone
      ? StringUtils.formatPhoneForServer(appointmentFormValues?.phone)
      : "";

    let email = appointmentFormValues?.email
      ? appointmentFormValues?.email
      : "";
    let name = appointmentFormValues?.name ? appointmentFormValues?.name : "";

    if (!email && user?.email) {
      email = user?.email;
    }

    if (!name && user?.name) {
      name = user?.name;
    }

    if (!phone && user?.phone) {
      phone = user?.phone;
    }

    let payload: any = {
      leadID: user?.customer?.leadID ? user?.customer?.leadID : null,
      customerID: user?.customerID ? user?.customerID : null,
      appointmentType:
        Constants.APPOINTMENT_TYPES["nc-consult"]?.APPOINTMENT_TYPE,
      dateTime: appointmentDateTime,
      name: name,
      email: email,
      phone: phone,
      notes: appointmentFormValues?.notes ? appointmentFormValues?.notes : "",
      goal: appointmentFormValues?.goal ? appointmentFormValues?.goal : "",
      forceAppointmentType: true,
      captchaToken:
        "Uot9isGEnMoyGRFRzyaorxGUR3reqddSUVRv2Acn3tsGuHmITP8Cka72rTipj60ogaW",
    };

    API.scheduleAppointment(store?._id, payload)
      .then(
        async (data: any) => {
          setExistingAppointment(data?.data?.data?.appointment);

          /*await StorageUtils.set(
              "checkout_appointment",
              data?.data?.data?.appointment
            );*/
        },
        (err) => {
          /**
           *
           */

          present({
            message: `Unable to schedule: ${
              err?.response?.data?.message
                ? err?.response?.data?.message
                : "Unknown error occurred."
            } Please try again`,
            icon: "closeCircle",
            color: "danger",
            layout: "baseline",
            mode: "ios",
            duration: 2500,
            buttons: [
              {
                text: "OK",
                role: "cancel",
              },
            ],
          });
        },
      )
      .finally(() => {
        setSubmitting(false);
      });
  };

  const loadState = () => {
    StorageUtils.get("user_customer").then((user) => {
      console.log("user", user);

      setUser(user);

      let storeID = user?.storeID
        ? user?.storeID
        : user?.customer?.storeID
        ? user?.customer?.storeID
        : null;

      if (storeID) {
        API.getStoreByID(storeID).then(
          (data: any) => {
            console.log("store", data?.data?.data?.store);

            StorageUtils.set("user_store", data?.data?.data?.store);

            setStore(data?.data?.data?.store);

            setLoading(false);
          },
          (e) => {
            console.log("error", e);
          },
        );
      }
    });
  };

  useIonViewDidEnter(() => {
    loadState();
  });

  return (
    <IonPage ref={pageRef}>
      {nativeMode ? (
        <>
          <IonHeader>
            <IonToolbar className="pln-native-toolbar">
              {hasPrevious ? (
                <IonButtons slot="start">
                  <IonBackButton></IonBackButton>
                </IonButtons>
              ) : null}
              <IonTitle>{pageName ? pageName : "Free Consultation"}</IonTitle>
            </IonToolbar>
          </IonHeader>
        </>
      ) : (
        <Navbar
          showBackButton={hasPrevious}
          actionButton={<></>}
          showMenuButton={false}
          pageName={pageName ? pageName : "Free Consultation"}
          onGoBack={() => {
            history.goBack();
          }}
        ></Navbar>
      )}

      <IonContent className="bg-white">
        <div className="ion-padding pln-onboarding-container">
          <div className="text-center">
            <div className="rounded w-full min-h-[300px] max-h-[300px] sm:max-h-[350px] mt-[1rem] mb-[1.5rem] flex justify-center">
              <img
                src={scheduler}
                alt="PLN+"
                className="w-auto h-full mx-auto max-h-[300px] sm:max-h-[350px] object-contain"
              />
            </div>

            <h2 className="font-medium font-[SourceSerif] text-2xl mb-[0.5rem]">
              {title ? title : "Book Your Free Coach Consultation"}
            </h2>

            <p className="" style={{ fontSize: 18 }}>
              {subtitle
                ? subtitle
                : "No pressure. No commitment. Just real insight into your health and a clear plan you can use right away."}
            </p>

            <div className="py-4">
              <div className="text-center text-xl font-medium font-[SourceSerif]">
                Here's What You'll Get:
              </div>
              <div className="my-3 text-center p-3 border rounded-lg">
                <div className="flex justify-center items-center mb-2.5">
                  <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="h-6 w-6 text-white"
                    >
                      <path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5" />
                      <path d="M3.22 13H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27" />
                    </svg>
                  </div>
                </div>
                <div className="text-lg font-[SourceSerif]">
                  A Personal Health Snapshot
                </div>
                <div className="text-base mt-1">
                  Step on our InBody scanner to see detailed metrics like
                  muscle, fat, metabolism, and hydration.
                </div>
              </div>
              <div className="my-3 p-3 border rounded-lg text-center">
                <div className="flex justify-center items-center mb-2.5">
                  <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="h-6 w-6 text-white"
                    >
                      <path d="M12 13V2l8 4-8 4" />
                      <path d="M20.561 10.222a9 9 0 1 1-12.55-5.29" />
                      <path d="M8.002 9.997a5 5 0 1 0 8.9 2.02" />
                    </svg>
                  </div>
                </div>
                <div className="text-lg font-[SourceSerif]">
                  Clarity On Your Goals
                </div>
                <div className="text-base mt-1">
                  Talk one-on-one with a coach about what you want to achieve
                  and the roadblocks you’ve faced.
                </div>
              </div>
              <div className="my-3 p-3 border rounded-lg text-center">
                <div className="flex justify-center items-center mb-2.5">
                  <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="h-6 w-6 text-white"
                    >
                      <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                      <path d="M2.62 13.8A2.25 2.25 0 1 1 6 10.836a2.25 2.25 0 1 1 3.38 2.966l-2.626 2.856a.998.998 0 0 1-1.507 0z" />
                      <path d="M4 6.005V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-1.9-1.376" />
                    </svg>
                  </div>
                </div>
                <div className="text-lg font-[SourceSerif]">
                  A Simple, Actionable Plan
                </div>
                <div className="text-base mt-1">
                  Walk away with a personalized nutrition roadmap tailored to
                  your body and lifestyle.
                </div>
              </div>
              <div className="my-3 p-3 border rounded-lg text-center">
                <div className="flex justify-center items-center mb-2.5">
                  <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="h-6 w-6 text-white"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                      <line x1="9" x2="9.01" y1="9" y2="9" />
                      <line x1="15" x2="15.01" y1="9" y2="9" />
                    </svg>
                  </div>
                </div>
                <div className="text-lg font-[SourceSerif]">
                  Next Steps Made Easy
                </div>
                <div className="text-base mt-1">
                  Walk away with a clear path forward and the confidence to
                  follow it.
                </div>
              </div>
            </div>
          </div>
        </div>
      </IonContent>
      <IonFooter>
        <IonToolbar
          className={`pln-native-toolbar-footer ${
            !Capacitor.isNativePlatform() ? "web" : ""
          }`}
        >
          {existingAppointment ? (
            <IonButton
              disabled={submitting}
              onClick={() => {
                next();
              }}
              expand="block"
              mode={
                Capacitor.isNativePlatform()
                  ? Capacitor.getPlatform() == "ios"
                    ? "ios"
                    : "md"
                  : "ios"
              }
            >
              {submitting ? <IonSpinner name="dots" /> : "Continue"}
            </IonButton>
          ) : (
            <>
              <IonButton
                disabled={submitting}
                onClick={() => {
                  setModalOpen(true);
                }}
                expand="block"
                mode={
                  Capacitor.isNativePlatform()
                    ? Capacitor.getPlatform() == "ios"
                      ? "ios"
                      : "md"
                    : "ios"
                }
              >
                {submitting ? <IonSpinner name="dots" /> : "Schedule"}
              </IonButton>
            </>
          )}
          {allowSkip && !existingAppointment ? (
            <IonButton
              disabled={submitting}
              onClick={async () => {
                next();
              }}
              expand="block"
              color="dark"
              fill="clear"
              mode={
                Capacitor.isNativePlatform()
                  ? Capacitor.getPlatform() == "ios"
                    ? "ios"
                    : "md"
                  : "ios"
              }
            >
              Maybe Later
            </IonButton>
          ) : null}
        </IonToolbar>
      </IonFooter>
      <IonModal
        mode={Capacitor.getPlatform() == "android" ? "md" : "ios"}
        className="modal-mealdetail"
        onDidDismiss={() => {
          setModalOpen(false);
          setAppointmentDateTime(null);
        }}
        isOpen={modalOpen}
      >
        <IonHeader>
          <IonToolbar
            mode={Capacitor.getPlatform() == "android" ? "md" : "ios"}
            className={
              Capacitor.isNativePlatform()
                ? "box-modal-toolbar-native"
                : "box-modal-toolbar-web"
            }
            style={{ borderBottom: "none" }}
            color="white"
          >
            <IonTitle>{pageName ? pageName : "Free Consultation"}</IonTitle>
            <IonButtons slot="start">
              <IonButton onClick={() => setModalOpen(false)}>Close</IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <div className="ion-padding pln-onboarding-container">
            <div className="">
              {existingAppointment ? (
                <AppointmentInformation
                  allowModification={false}
                  onChange={(appointment: any) => {
                    setExistingAppointment(appointment);
                  }}
                  onCancel={(appointment: any) => {
                    setExistingAppointment(appointment);
                  }}
                  appointment={existingAppointment}
                ></AppointmentInformation>
              ) : (
                <>
                  <div className="text-center">
                    <h2 className="font-medium font-[SourceSerif] text-2xl mb-[0.25rem]">
                      {title ? title : "Book Your Free Coach Consultation"}
                    </h2>
                    <p className="" style={{ fontSize: 18 }}>
                      {subtitle
                        ? subtitle
                        : "Let's get your consultation scheduled! You'll meet one on one with a coach to discuss your goals and optimize your plan for success."}
                    </p>
                  </div>
                  <div className="mb-4 mt-4">
                    {loading ? (
                      <>
                        <IonSkeletonText
                          className="h-[66px] rounded-lg"
                          animated={true}
                        />
                      </>
                    ) : (
                      <>
                        <div
                          className="border p-[0.75rem] mb-4 mt-1"
                          style={{ borderRadius: 6 }}
                        >
                          <div className="flex gap-x-3 items-center">
                            <div className="">
                              <IonIcon
                                icon={navigateCircle}
                                className="text-orange-500 h-8 w-8 relative top-[1px]"
                              />
                            </div>
                            <div size-xs="" className="grow">
                              <h5 className="text-dark m-0 font-weight-bold">
                                {store?.name
                                  ?.replace("Project LeanNation", "PLN")
                                  .trim()}
                              </h5>
                              <p className="m-0" style={{ fontSize: 14 }}>
                                {store?.location?.address?.formattedAddress}
                              </p>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>

                  {loading ? (
                    <IonSkeletonText
                      className="h-[400px] rounded-lg"
                      animated={true}
                    />
                  ) : (
                    <SchedulingCalendarV2
                      store={store}
                      appointmentType={
                        Constants.APPOINTMENT_TYPES["nc-consult"]
                      }
                      value={appointmentDate}
                      onDateSelected={(date: any) => {
                        console.log("Date Selected", date);

                        setAppointmentDateTime(date);
                      }}
                    ></SchedulingCalendarV2>
                  )}
                </>
              )}
            </div>
          </div>
        </IonContent>
        <IonFooter>
          <IonToolbar
            className={`pln-native-toolbar-footer ${
              !Capacitor.isNativePlatform() ? "web" : ""
            }`}
          >
            <IonButton
              disabled={!appointmentDateTime || submitting}
              onClick={() => {
                // TODO: update billing address

                if (existingAppointment) {
                  setModalOpen(false);

                  return next();
                }

                scheduleNewMemberConsult();
              }}
              expand="block"
              mode={
                Capacitor.isNativePlatform()
                  ? Capacitor.getPlatform() == "ios"
                    ? "ios"
                    : "md"
                  : "ios"
              }
            >
              {submitting ? (
                <IonSpinner name="dots" />
              ) : (
                <>
                  {existingAppointment ? (
                    "Continue"
                  ) : (
                    <>
                      {!appointmentDateTime
                        ? "Choose Date & Time To Schedule"
                        : "Schedule"}
                      {appointmentDateTime ? (
                        <>
                          &nbsp;
                          {moment(appointmentDateTime).format("MMM Do, h:mm A")}
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </>
              )}
            </IonButton>
          </IonToolbar>
        </IonFooter>
      </IonModal>
    </IonPage>
  );
};

export default ConsultationSchedulerPage;
